import Component_InstancedMeshHex_45bf5657e6571a89d6c12a409950f3bf from "../../../../content/examples/basic/instanced-mesh-hex/InstancedMeshHex";
import Devtool_InstancedMeshHex_45bf5657e6571a89d6c12a409950f3bf from "!!@devtool/loader!../../../../content/examples/basic/instanced-mesh-hex/InstancedMeshHex";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_InstancedMeshHex_45bf5657e6571a89d6c12a409950f3bf,
  Devtool_InstancedMeshHex_45bf5657e6571a89d6c12a409950f3bf,
  DevTool,
  React
};